// navigationHelpers.js
export const copyMetaTags = [
  'description', 'keywords', 'author', 'language',
  'og:title', 'og:description', 'og:url', 'og:type', 'og:locale', 'og:site_name', 'og:image',
  'twitter:card', 'dcterms.title', 'dcterms.description', 'dcterms.creator',
  'dcterms.format', 'dcterms.identifier', 'dcterms.language',
  'geo.position', 'ICBM'
]

export const CLS = {
  active: 'nav-item-active',
  preActive: 'nav-item-pre-active',
  pageActive: 'page-active',
  pagePreActive: 'page-pre-active',
  transitioning: 'page-transitioning',
  aboutPreOpen: 'about-pre-open',
  aboutOpen: 'about-is-open'
}

export const wait = ms => new Promise(r => setTimeout(r, ms))

export const openItem = async item => {
  item.classList.add(CLS.preActive)
  await wait(10)
  item.classList.add(CLS.active)
  await wait(600)
  document.body.classList.add(CLS.pagePreActive)
  await wait(100)
  document.body.classList.add(CLS.pageActive)
}

export const closeItem = async item => {
  document.body.classList.remove(CLS.pageActive)
  await wait(300)
  item.classList.remove(CLS.active)
  await wait(300)
  item.classList.remove(CLS.preActive)
  await wait(100)
  document.body.classList.remove(CLS.pagePreActive)
}

export const openAbout = async () => {
  document.body.classList.add(CLS.aboutPreOpen)
  await wait(10)
  document.body.classList.add(CLS.aboutOpen)
  await wait(600)
  document.body.classList.add(CLS.pagePreActive)
  await wait(100)
  document.body.classList.add(CLS.pageActive)
}

export const closeAbout = async () => {
  document.body.classList.remove(CLS.pageActive)
  await wait(300)
  document.body.classList.remove(CLS.aboutOpen)
  await wait(300)
  document.body.classList.remove(CLS.aboutPreOpen)
  await wait(100)
  document.body.classList.remove(CLS.pagePreActive)
}
